import { useCallback, useRef } from "react";
import { useDocumentEvent } from "@culturehq/hooks";

const useFullScreen = onClose => {
  useDocumentEvent(
    "fullscreenchange",
    useCallback(
      () => {
        if (!document.fullscreenElement) {
          onClose();
        }
      },
      [onClose]
    )
  );

  const elementRef = useRef();
  const onRequest = useCallback(
    () => {
      const element = elementRef.current;

      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      }
    },
    [elementRef]
  );

  return [elementRef, onRequest];
};

export default useFullScreen;
